import { RdbSession, } from "@hyper-hyper-space/hhs3_rdb_runtime";
export { KeyPassphraseRequiredError } from "@hyper-hyper-space/hhs3_rdb_runtime";
export class ReplSession extends RdbSession {
    constructor(options) {
        var _a, _b, _c, _d, _e, _f;
        const sessionOptions = {
            workspace: options.workspace,
            keyVault: options.keyVault,
            refAutoUpdate: (_a = options.refAutoUpdate) !== null && _a !== void 0 ? _a : 'off',
            createUuid: options.createUuid,
        };
        super(sessionOptions);
        this.outputMode = (_b = options.outputMode) !== null && _b !== void 0 ? _b : 'table';
        this.hashWidth = (_c = options.hashWidth) !== null && _c !== void 0 ? _c : 'auto';
        this.hashLabels = (_d = options.hashLabels) !== null && _d !== void 0 ? _d : false;
        this.promptForKeys = (_e = options.promptForKeys) !== null && _e !== void 0 ? _e : false;
        this.stopOnError = (_f = options.stopOnError) !== null && _f !== void 0 ? _f : true;
    }
    get keystore() {
        return this.keyVault;
    }
    set keystore(store) {
        this.keyVault = store;
    }
    enableReplDefaults() {
        this.hashLabels = true;
        this.refAutoUpdate = 'auto';
    }
    enableScriptDefaults() {
        this.hashWidth = 'full';
        this.refAutoUpdate = 'off';
    }
    setOutputMode(mode) {
        this.outputMode = mode;
    }
    setHashWidth(width) {
        this.hashWidth = width;
    }
    setHashLabels(on) {
        this.hashLabels = on;
    }
    setPromptForKeys(on) {
        this.promptForKeys = on;
    }
}
